<template>
  <p class="price dated">
    <pu-price-losenge
      :price="price"
      data-test="dated-pitch-price"
      class="pitch-price"
    />
    <translate class="pricing-period per-stay"> per stay </translate>
  </p>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { MoneyType as Money } from '~/utility/money'

@Component
class PricingPeriodDated extends Vue {
  @Prop({ required: true })
  price: Money
}

export default toNative(PricingPeriodDated)
</script>
<style scoped>
.price {
  color: var(--colour-header-light-blue);
  text-align: right;
  line-height: 1.2;
}

.price.dated {
  line-height: 1.1;
}

.pitch-price {
  font-size: var(--body);
}

.pricing-period {
  color: var(--colour-text-light);
  display: block;
  font-size: var(--tiny);
  font-weight: normal;
  min-width: 5em;
}
</style>
